const ProjectRoutes = [
    {
        path: "/",
        name: "Project",
        component: () =>
          import(
            /* webpackChunkName: "ProjectModule" */ "./views/Index.vue"
          ),
      },
      {
        path: "/project/create",
        name: "CreateProject",
        meta: {
          requiresOwner: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "ProjectModule" */ "./views/Create.vue"
        ),
      },
      {
        path: "/project/settings",
        name: "ProjectSettings",
        meta: {
          requiresOwner: true,
        },
        component: () =>
          import(
            /* webpackChunkName: "ProjectModule" */ "./views/Settings.vue"
        ),
      },
  ];
  
  export default ProjectRoutes;
  